import * as React from "react";
import "./DebugCenter.less";
import {injectIntl, InjectedIntlProps, FormattedMessage} from "react-intl";
import {RouteComponentProps} from "react-router";
import {Form, Select, Button, Input} from "antd";
import {Link} from "@netless/i18n-react-router";
import {FormInstance} from "antd/lib/form";

const FormItem = Form.Item;
const Option = Select.Option;

export type DebugRoomProps = RouteComponentProps<{ uuid?: string, roomToken?: string }> & InjectedIntlProps;

class DebugReplay extends React.Component<DebugRoomProps, {}> {
    private readonly formRef: React.RefObject<FormInstance> = React.createRef();

    public constructor(props: DebugRoomProps) {
        super(props);
    }

    public componentDidMount(): void {
        const {uuid, roomToken} = this.props.match.params;
        if (uuid) {
            this.formRef.current!.setFieldsValue({
                room_uuid: uuid,
            });
        }
        if (roomToken) {
            this.formRef.current!.setFieldsValue({
                room_token: roomToken,
            });
        }
        this.formRef.current!.setFieldsValue({
            version: "v2.7.1",
        });
    }

    private handleReplay = (values: any): void => {
        const host = "https://debug.netless.link";
        if (values.start_time && values.end_time) {
            window.open(`${host}/${values.version}/replay/${values.room_uuid}?token=${values.room_token}&beginAt=${values.start_time}&duration=${values.end_time - values.start_time}`, "“_blank”");
        } else {
            window.open(`${host}/${values.version}/replay/${values.room_uuid}?token=${values.room_token}`, "“_blank”");
        }
    }

    public render(): React.ReactNode {
        const {intl} = this.props;
        return (
            <div className="add-storage-box">
                <div className="add-storage-mid-box">
                    <div className="room-mid-box">
                        <div className="room-title" key={"title"}>
                            <FormattedMessage
                                id="debug.replay-room"
                            />
                        </div>
                        <div className="room-inner">
                            <FormattedMessage
                                id="debug.input-tips"
                            />
                        </div>
                        <Form ref={this.formRef} key={"sdd"} onFinish={this.handleReplay} className="login-form">
                            <FormItem
                                rules={[{
                                    required: true,
                                    message: `${intl.formatMessage({id: "debug.please-input"})} roomToken`,
                                }]}
                                name={"room_token"}
                            >
                                <Input
                                    size={"large"}
                                    placeholder="roomToken"/>
                            </FormItem>
                            <FormItem
                                rules={[{
                                    required: true,
                                    message: `${intl.formatMessage({id: "debug.please-input"})} uuid`,
                                }]}
                                name={"room_uuid"}
                            >
                                <Input
                                    size={"large"}
                                    placeholder="uuid"/>
                            </FormItem>
                            <FormItem
                                name={"version"}
                                rules={[{required: true, message: intl.formatMessage({id: "debug.sdk-version"})}]}
                            >
                                <Select size={"large"} placeholder={intl.formatMessage({id: "debug.sdk-version"})}
                                        className="room-select-box-inner">
                                    <Option value="v2.7.1">v2.7.1</Option>
                                    <Option value="v2.7.0">v2.7.0</Option>
                                    <Option value="v2.6.4">v2.6.4</Option>
                                    <Option value="v2.6.3">v2.6.3</Option>
                                    <Option value="v2.6.1">v2.6.1</Option>
                                    <Option value="v2.6.0">v2.6.0</Option>
                                    <Option value="v2.5.10">v2.5.10</Option>
                                    <Option value="v2.5.8">v2.5.8</Option>
                                    <Option value="v2.3.19">v2.3.19</Option>
                                </Select>
                            </FormItem>
                            <FormItem
                                name={"start_time"}
                                rules={[{required: false, message: intl.formatMessage({id: "debug.start-time"})}]}
                            >
                                <Input
                                    size={"large"}
                                    placeholder={`${intl.formatMessage({id: "debug.start-time"})} (${intl.formatMessage({id: "debug.optional"})})`}/>
                            </FormItem>
                            <FormItem
                                name={"end_time"}
                                rules={[{required: false, message: intl.formatMessage({id: "debug.start-time"})}]}
                            >
                                <Input
                                    size={"large"}
                                    placeholder={`${intl.formatMessage({id: "debug.start-time"})} (${intl.formatMessage({id: "debug.optional"})})`}/>
                            </FormItem>
                            <FormItem>
                                <Button
                                    size={"large"}
                                    type="primary"
                                    htmlType="submit"
                                    className="room-button">
                                    <FormattedMessage
                                        id="debug.enter-replay"
                                    />
                                </Button>
                            </FormItem>
                            <Link to="/debug-center/">
                                <Button
                                    size={"large"}
                                    className="room-button">
                                    <FormattedMessage
                                        id="debug.go-back"
                                    />
                                </Button>
                            </Link>
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}


export default injectIntl(DebugReplay);



// WEBPACK FOOTER //
// ./src/components/portal/debugCenter/DebugReplay.tsx